/*eslint-disable*/

import React, { useMemo } from 'react'
import { IAnimal, ProductiveAnimalDTO } from 'src/dto/animal.dto'
import { useGetProductiveAnimalList } from 'src/hooks/api/animal'
import { useStyles } from './styles'
import { Loading } from 'src/components'
import { calculateDaysSinceLastWeighing, isToday } from '../utils/functions'
import { formatDate } from 'src/utils'

interface IProductiveHistory {
  data?: IAnimal
}

type ProductiveHistoryItem = ProductiveAnimalDTO & {
  days: number
  daysLabel: string
}

export const ProductiveHistory: React.FC<IProductiveHistory> = ({ data }) => {
  const styles = useStyles()

  const {
    data: productiveHistory,
    isLoading,
    isError,
    refetch,
    isFetching
  } = useGetProductiveAnimalList(data?.idAnimal || '')

  const processedHistory: ProductiveHistoryItem[] = useMemo(() => {
    if (!productiveHistory) return []

    const sorted = [...productiveHistory].sort((a, b) => new Date(b.data).getTime() - new Date(a.data).getTime())

    return sorted.map((record, index) => {
      const prevRecord = sorted[index - 1]

      const days = prevRecord
        ? calculateDaysSinceLastWeighing(record.data, prevRecord.data)
        : calculateDaysSinceLastWeighing(record.data)

      const isFirst = index === 0

      let daysLabel = ''

      if (isFirst) {
        daysLabel = isToday(record.data) ? 'Hoje' : 'Última pesagem'
      } else {
        daysLabel = `${days} dias`
      }

      return {
        ...record,
        days,
        daysLabel
      }
    })
  }, [productiveHistory])

  if (isLoading || isFetching || isError) {
    return (
      <div className={styles.container}>
        <Loading isError={isError} refetch={refetch} />
      </div>
    )
  }

  if (!processedHistory.length) {
    return <p style={{ color: '#000' }}>Nenhum registro de histórico produtivo encontrado.</p>
  }

  return (
    <div className={styles.container}>
      <div className={styles.cardList}>
        {processedHistory.map((record, index) => (
          <div key={record.idProdutivo || index} className={styles.card}>
            <div className={styles.cardHeader}>
              <span className={styles.date}>{formatDate(record.data)}</span>
              <span className={styles.daysCount}>{record.daysLabel}</span>
            </div>

            <div className={styles.cardBody}>
              <span className={styles.weight}>Peso: {record.peso} kg</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
